import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FITHWinFieldController} from "./winpresentation/FITHWinFieldController";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {Skinner} from "./Skinner";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";

export class FireInTheHole extends SlotGame {
    private skinner:Skinner;

    constructor(gameModuleConfig: IGameModuleConfig) {
        super(gameModuleConfig);
        const validSkinIds:string[] = [
            "crypticcarnival",
            "ug",
            "ozzo",
            "nexus",
            "747"
        ]
        this.skinner = new Skinner(validSkinIds);
    }

    protected createWinFieldController(): FITHWinFieldController {
        return new FITHWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L2",
                    "L5",
                    "D",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "M5",
                    "M1",
                    "L3",
                    "X",
                    "X",
                    "D"
                ],
                [
                    "M3",
                    "M3",
                    "M5",
                    "X",
                    "X",
                    "D"
                ],
                [
                    "L3",
                    "M4",
                    "D",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "L2",
                    "L2",
                    "M2",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "L2",
                    "M2",
                    "M2",
                    "X",
                    "X",
                    "D"
                ]
            ],
            "evaluatedArea": [
                [
                    "L2",
                    "L5",
                    "D",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "M5",
                    "M1",
                    "L3",
                    "X",
                    "X",
                    "D"
                ],
                [
                    "M3",
                    "M3",
                    "M5",
                    "X",
                    "X",
                    "D"
                ],
                [
                    "L3",
                    "M4",
                    "D",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "L2",
                    "L2",
                    "M2",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "L2",
                    "M2",
                    "M2",
                    "X",
                    "X",
                    "D"
                ]
            ],
            "betWayWins": [],
            "thisAvalancheWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "totalNumberOfWays": 324,
            "reelsAfterCollapse": [
                [
                    "L2",
                    "L5",
                    "D",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "M5",
                    "M1",
                    "L3",
                    "X",
                    "X",
                    "D"
                ],
                [
                    "M3",
                    "M3",
                    "M5",
                    "X",
                    "X",
                    "D"
                ],
                [
                    "L3",
                    "M4",
                    "D",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "L2",
                    "L2",
                    "M2",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "L2",
                    "M2",
                    "M2",
                    "X",
                    "X",
                    "D"
                ]
            ],
            "allWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "explodePositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "newSymbols": [],
            "totalAvalancheRoundWinnings": 0,
            "baseActiveRowsBefore": 3,
            "baseActiveRowsAfter": 3,
            "bonusValuesAfterSpin": [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "bonusPositionsBeforeSpin": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bonusNewPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bonusWinTimesBetBefore": 0,
            "bonusWinTimesBetAfter": 0,
            "symbolOverlayBefore": [
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ]
            ],
            "symbolOverlayAfter": [
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "D",
                    "D",
                    "D"
                ]
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN_3_SCATTERS",
                    "type": "FREESPIN",
                    "price": 60
                },
                {
                    "name": "FREESPIN_4_SCATTERS",
                    "type": "FREESPIN",
                    "price": 157
                },
                {
                    "name": "FREESPIN_5_SCATTERS",
                    "type": "FREESPIN",
                    "price": 500
                }
            ],
            "wasFeatureBuy": false,
            "wildTransform": false,
            "wildTransformSymbolPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "wildTransformPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "openPositionsBonusBefore": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "openPositionsBonusAfter": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "waysWonTotalRound": 0,
            "currentMultiplier": 1,
            "multiplierNextSpin": 1,
            "dynamiteExtraValues": [],
            "dwarfPosition": [
                -1,
                -1
            ],
            "bottomCollectorActivated": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "brokeTheBank": false
        };
    }

    getReady():Promise<NolimitPlugin> {
        return super.getReady().then((value: NolimitPlugin) => {

            //DO THIS:
            // + update paytable for skinned images to dynamic path
            if (this.skinner.skinId != undefined) {
                //Source folder for skin assets e.g "resources/images/skinName";
                const assetPath:string = "resources/images/";

                const replaceMap:Map<string, string> = new Map();
                replaceMap.set("logo", "introLogoOverride.png");
                replaceMap.set("B/B", "B.png");
                replaceMap.set("B/B_bg", "B_bg.png");
                replaceMap.set("B/B_main", "B_main.png");
                replaceMap.set("B/B_spin", "B_spin.png");
                replaceMap.set("FREESPIN_3_SCATTERS", "FREESPIN_3_SCATTERS.png");
                replaceMap.set("FREESPIN_4_SCATTERS", "FREESPIN_4_SCATTERS.png");
                replaceMap.set("FREESPIN_5_SCATTERS", "FREESPIN_5_SCATTERS.png");


                return this.skinner.loadSkin(assetPath, replaceMap).then(() => {
                    return value
                });

            }

            return value;
        });
    }

    public getPaytable():Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.api.resources.getStaticRoot());

        const flagData = {
            showLowProbabilityGfx: FireInTheHole.api.gameClientConfiguration.showLowProbabilityGfx,
            replaceWincapInfo: FireInTheHole.api.gameClientConfiguration.replaceWincapInfo,
            isJurisdictionUSPA: FireInTheHole.api.gameClientConfiguration.jurisdictionName === "US-PA",// added for #381
            isNJServer: !!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1),
            isJurisdictionUSPAorNJ: FireInTheHole.api.gameClientConfiguration.jurisdictionName === "US-PA" || FireInTheHole.api.gameClientConfiguration.jurisdictionName === "US-NJ" // added for 364
        };

        templateLoader.add({
            name : "Paytable",
            url : "nolimit/screens/paytable.mustache"
        });


        let imagPath = "screens/images/";
        if (this.skinner.skinId != undefined){
            imagPath = `../resources/images/${this.skinner.skinId}/`;
        }

        return templateLoader.load().then((assets:TemplateAsset[]) => {
            for(let asset of assets) {
                if(asset.name == "Paytable" && asset.loadedData) {
                    asset.loadedData = asset.loadedData.replace(new RegExp(/({{imgPath}})/, 'g'), imagPath);
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        }).then((value: string) => {
            return FireInTheHole.api.translations.render(value, flagData);
        });
    }

}